import { atom } from 'jotai';

interface IStyles {
  [key: string]: string;
}

export const atomIframeTransport = atom<IStyles>({});
